import React from "react";
import { useTransition, config, animated } from "@react-spring/web";
import { Container, Wrapper, Column } from "./styled-components";

export interface AnimatedContainerProps {
  isVisible?: boolean;
  isFloating?: boolean;
  propRef?: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
}

const AnimatedContainer = animated(Container);
const AnimatedColumn = animated(Column);

const AnimatedContainerComp = ({
  isFloating = true,
  isVisible,
  propRef,
  children
}: AnimatedContainerProps) => {
  const transition = useTransition(isVisible, {
    config: isVisible ? { ...config.stiff } : { duration: 300 },
    from: { opacity: 0, transform: `translate3d(0px, 100px, 0px)` },
    enter: { opacity: 1, transform: `translate3d(0px, 0px, 0px)` },
    leave: { opacity: 0, transform: `translate3d(0px, 100px, 0px)` }
  });

  const ContainerComponent = isFloating ? AnimatedContainer : AnimatedColumn;
  const WrapperComponent = isFloating ? Wrapper : Column;

  return (
    <>
      {transition(
        (styles, isOpen) =>
          isOpen && (
            <ContainerComponent
              ref={propRef}
              {...(isFloating ? { style: styles } : {})}
              data-qa-label="bet-slip-container"
            >
              <WrapperComponent
                data-qa-label="bet-slip-wrapper"
                id="bet-slip-wrapper"
              >
                {children}
              </WrapperComponent>
            </ContainerComponent>
          )
      )}
    </>
  );
};

export default AnimatedContainerComp;
